<template>
  <div>
    <h3>Insider client info</h3>

    <table class="props-compact">
      <tr>
        <th>Time (ISO string)</th>
        <td>{{nowISOStr}}</td>
      </tr>
      <tr>
        <th>Time (UTC string)</th>
        <td>{{nowUTCStr}}</td>
      </tr>
      <tr>
        <th>Time (locale string)</th>
        <td>{{nowLocaleStr}}</td>
      </tr>
      <tr>
        <th>Timezone offset (in minutes)</th>
        <td>{{timezoneOffset}}</td>
      </tr>
    </table>

    <hr>

    <table class="props-compact">
      <tr>
        <th>Time</th>
        <td>{{t | getMomentStr}}</td>
      </tr>
      <tr>
        <th>Game version</th>
        <td>{{GAME_VERSION}}</td>
      </tr>
      <tr>
        <th>Revision hash</th>
        <td>{{REVISION_HASH}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { GAME_VERSION  } from '../autogen/version';
import { REVISION_HASH } from '../autogen/version';

export default {
  name: 'SystemInfoInsiderClient',

  data() {
    const now = new Date();
    const nowISOStr    = now.toISOString();
    const nowUTCStr    = now.toUTCString();
    const nowLocaleStr = now.toLocaleString();

    return {
      nowISOStr: nowISOStr,
      nowUTCStr: nowUTCStr,
      nowLocaleStr: nowLocaleStr,
      timezoneOffset: now.getTimezoneOffset(),

      t: Date.now() / 1000,

      GAME_VERSION,
      REVISION_HASH,
    };
  },
};
</script>
